<template>
    <v-container class="pa-5" fluid>
        <ProductGroupFactorDialog
            :is-open="productGroupFactorDialog"
            :product-group-factor-data="currentProductGroupFactor"
            @on-confirm="getProductGroupFactors"
            @on-close="closeProductGroupFactorDialog"
        />
        <v-row align="center" dense>
            <v-col cols="12" md="6">
                <v-container fluid class="pa-0">
                    <v-row dense>
                        <v-col cols="auto">
                            <page-title>Współczynnik grupy produktowej</page-title>
                        </v-col>
                        <v-col cols="auto">
                            <SelectMenu />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>

            <v-col cols="12" md="6">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" md="8" lg="6">
                            <v-text-field
                                v-model="filters.search"
                                append-icon="mdi-magnify"
                                label="Szukaj..."
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('search')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="productGroupFactors"
                        :loading="productGroupFactorsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        name="productGroupFactorData"
                        @pagination="updatePagination"
                    >
                        <template #item.productTypeGroup="{item}">
                            {{ item.productTypeGroup.name }}
                        </template>
                        <template #item.name="{item}">
                            {{ item.name }}
                        </template>
                        <template #item.type="{item}">
                            {{ item.type.name }}
                        </template>
                        <template #item.value="{item}">
                            {{ item.value }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Edytuj"
                                            v-on="on"
                                            @click="showEditProductGroupFactorDialog(item)"
                                        >
                                            <v-icon color="teal">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edytuj</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import SelectMenu from '@/views/Configurations/CalculationsCosts/Common/SelectMenu'
import ProductGroupFactorDialog from './ProductGroupFactorDialog'

export default {
    name: 'ProductGroupFactor',
    components: {
        PageTitle,
        SelectMenu,
        ProductGroupFactorDialog
    },
    mixins: [
        filters,
        pagination,
        tooltipDelay
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('configurations/calculationsCosts/clearProductGroupFactorsFilters')
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            currentProductGroupFactor: {},
            productGroupFactorDialog: false,
            headers: [
                {
                    text: 'Produkt',
                    value: 'productTypeGroup',
                    sortable: false
                },
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Typ',
                    value: 'type',
                    sortable: false,
                    width: 200
                },
                {
                    text: 'Narzut %',
                    value: 'value',
                    sortable: false,
                    width: 200
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        productGroupFactors() {
            return this.$store.state.configurations.calculationsCosts.productGroupFactors.productGroupFactors
        },
        productGroupFactorsLoading() {
            return this.$store.state.configurations.calculationsCosts.productGroupFactors.productGroupFactorsLoading
        },
        savedFilters() {
            return this.$store.state.configurations.calculationsCosts.productGroupFactors.filters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    mounted() {
        this.getProductGroupFactors()
    },
    methods: {
        getProductGroupFactors() {
            this.$store.dispatch('configurations/calculationsCosts/getProductGroupFactors', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showEditProductGroupFactorDialog(productGroupFactor) {
            this.currentProductGroupFactor = productGroupFactor
            this.productGroupFactorDialog = true
        },
        closeProductGroupFactorDialog() {
            this.productGroupFactorDialog = false

            setTimeout(() => {
                this.currentProductGroupFactor = {}
            }, 500)
        },
        changeFilter() {
            this.$store.dispatch('configurations/calculationsCosts/setProductGroupFactorsFilters', this.filters)
                .catch(error => {
                    errorHandler(error)
                })
            this.resetPagination()
            this.getProductGroupFactors()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getProductGroupFactors()
            }
            this.clearPaginationPending()
        },
    }
}
</script>